import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatIST } from "@/lib/format";
import { PageHeader } from "@/components/Shell";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2, History } from "lucide-react";

export default function AdminActivity() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/activity-log").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  return (
    <div>
      <PageHeader title="Admin Activity Log" desc="Immutable audit trail of every admin action." />
      <div className="vp-card rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="border-white/5 hover:bg-transparent">
                <TableHead className="text-slate-400">Admin</TableHead><TableHead className="text-slate-400">Action</TableHead>
                <TableHead className="text-slate-400">Details</TableHead><TableHead className="text-slate-400">Time (IST)</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {!rows ? <TableRow><TableCell colSpan={4} className="py-10 text-center"><Loader2 className="h-6 w-6 animate-spin text-emerald-400 mx-auto" /></TableCell></TableRow> :
                rows.length === 0 ? <TableRow><TableCell colSpan={4} className="text-center text-slate-500 py-10"><History className="h-6 w-6 mx-auto mb-2 opacity-50" />No activity yet.</TableCell></TableRow> :
                rows.map((l) => (
                  <TableRow key={l.id} className="border-white/5">
                    <TableCell className="text-sm">{l.admin_email}</TableCell>
                    <TableCell><span className="rounded-md bg-cyan-500/15 text-cyan-300 px-2 py-0.5 text-xs font-mono">{l.action}</span></TableCell>
                    <TableCell className="text-sm text-slate-400">{l.details}</TableCell>
                    <TableCell className="text-xs text-slate-500 font-mono">{formatIST(l.created_at)}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
